/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accMultiSelectedNodesActions', [
        'template',
        'nodeModalAction',
        'nodeMoveModal',
        'nodeDownload',
        '$translate',
        'purgeAllRevisions',
        (
            template,
            nodeModalAction,
            nodeMoveModal,
            nodeDownload,
            $translate,
            purgeAllRevisions
        ) => ({
            scope: {
                selectedNodes: '='
            },
            replace: true,
            templateUrl: template('nodes/multi_select/_selected_nodes_actions'),
            controller: [
                '$scope',
                ($scope) => {
                    $scope.$watchCollection('selectedNodes', () => {
                        _updateCount();
                        _updateSummary();
                    });

                    $scope.canBe = (method) => $scope.selectedNodes.every((node) => node[`canBe${method}`]());

                    $scope.canBeUnsubscribedOrDeleted = () => $scope.selectedNodes.every((node) => node.canBeUnsubscribedFrom() || node.canBeDeleted()) &&
                        !$scope.canBe('UnsubscribedFrom') && !$scope.canBe('Deleted');

                    $scope.canPurgeAllRevisions = () => $scope.selectedNodes.every((node) => node.canPurgeAllRevisions());

                    $scope.downloadAll = () => angular.forEach($scope.selectedNodes, (node) => nodeDownload(node));

                    $scope.openMoveDialog = () => nodeMoveModal($scope);

                    $scope.openCopyDialog = () => nodeModalAction($scope, {
                        modalController: 'CopyMoveController',
                        modalType: 'confirm',
                        modalAction: 'copy',
                        modalBodyTemplate: 'modals/actions/transfer',
                        modalFooterTemplate: 'nodes/_transfer_modal_footer',
                        modalTitle: 'Copy',
                        modalActionButton: $translate.instant('Copy'),
                        modalNotifications: true
                    });

                    $scope.purgeAllRevisions = () => purgeAllRevisions($scope.selectedNodes);

                    $scope.close = () => $scope.$parent.resetMultiSelect();

                    const _updateCount = () => {
                        $scope.selectionCount = {
                            folders: 0,
                            files: 0
                        };

                        angular.forEach($scope.selectedNodes, (node) => $scope.selectionCount[node.is_directory ? 'folders' : 'files']++);
                    };

                    const _updateSummary = () => {
                        const translations = [];

                        if ($scope.selectionCount['files'] > 0) {
                            translations.push(
                                $translate.instant(
                                    'selected_nodes_multi_select_files',
                                    { COUNT: $scope.selectionCount.files },
                                    'messageformat'
                                )
                            );
                        }

                        if ($scope.selectionCount['folders'] > 0) {
                            translations.push(
                                $translate.instant(
                                    'selected_nodes_multi_select_folders',
                                    { COUNT: $scope.selectionCount.folders },
                                    'messageformat'
                                )
                            );
                        }

                        $scope.selectionCountSummary = translations.join(', ');
                    };
                }
            ]
        })
    ]);
